module.exports = __webpack_public_path__ + "img/worth_2.2b10d713.png";